import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ButtonVariant } from '@brg/ui'
import { API, Endpoints } from '@brg/api'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import { Wrapper, Title, Description, ButtonRow, ActionButton, CloseWrapper } from './styles'

export type EnrollCourseVariant = 'success' | 'already-member' | 'no-payment'

interface EnrollCourseModalProps {
  variant: EnrollCourseVariant
  courseName?: string
  courseUrl?: string
  teamId?: string
  isPaidCourse?: boolean
}

const TITLE_KEYS: Record<EnrollCourseVariant, string> = {
  success: 'enroll_course_modal.titles.success',
  'already-member': 'enroll_course_modal.titles.already_member',
  'no-payment': 'enroll_course_modal.titles.no_payment',
}

export const EnrollCourseModal: FC<EnrollCourseModalProps> = ({
  variant,
  courseName = '',
  courseUrl = '',
  teamId = '',
  isPaidCourse = false,
}) => {
  const modal = useModal()
  const history = useHistory()
  const { t } = useTranslation()

  const description = (() => {
    if (variant === 'success') {
      return courseName
        ? t('enroll_course_modal.descriptions.success', { courseName })
        : t('enroll_course_modal.descriptions.success_no_name')
    }
    if (variant === 'already-member') {
      return t('enroll_course_modal.descriptions.already_member')
    }
    return t('enroll_course_modal.descriptions.no_payment')
  })()

  const handleGoToCourse = () => {
    modal.hide()
    if (courseUrl) {
      history.push(courseUrl)
    }
  }

  const handleLeave = async () => {
    try {
      await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/LMS/RemoveMemberFromExternalCourse')
        .body({ teamId })
        .post()
        .send()
    } catch (err) {
      console.error('[EnrollCourseModal] leave course error', err)
    }
    modal.hide()
  }

  const showGoToCourse = variant !== 'no-payment'
  const showLeave = variant !== 'no-payment' && !isPaidCourse

  return (
    <Wrapper>
      <CloseWrapper>
        <IconCloseMob onClick={() => modal.hide()} />
      </CloseWrapper>

      <Title>{t(TITLE_KEYS[variant])}</Title>
      <Description>{description}</Description>

      <ButtonRow>
        <ActionButton width={220} variant={ButtonVariant.Hollow} onClick={() => modal.hide()}>
          {t('enroll_course_modal.buttons.close')}
        </ActionButton>
        {showGoToCourse && (
          <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleGoToCourse}>
            {t('enroll_course_modal.buttons.go_to_course')}
          </ActionButton>
        )}
        {showLeave && (
          <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleLeave}>
            {t('enroll_course_modal.buttons.leave_course')}
          </ActionButton>
        )}
      </ButtonRow>
    </Wrapper>
  )
}
import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ButtonVariant } from '@brg/ui'
import { API, Endpoints } from '@brg/api'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import { Wrapper, Title, Description, ButtonRow, ActionButton, CloseWrapper } from './styles'

export type EnrollCourseVariant = 'success' | 'already-member' | 'no-payment'

interface EnrollCourseModalProps {
  variant: EnrollCourseVariant
  courseName?: string
  courseUrl?: string
  teamId?: string
  isPaidCourse?: boolean
}

const TITLE_KEYS: Record<EnrollCourseVariant, string> = {
  success: 'enroll_course_modal.titles.success',
  'already-member': 'enroll_course_modal.titles.already_member',
  'no-payment': 'enroll_course_modal.titles.no_payment',
}

export const EnrollCourseModal: FC<EnrollCourseModalProps> = ({
  variant,
  courseName = '',
  courseUrl = '',
  teamId = '',
  isPaidCourse = false,
}) => {
  const modal = useModal()
  const history = useHistory()
  const { t } = useTranslation()

  const description = (() => {
    if (variant === 'success') {
      return courseName
        ? t('enroll_course_modal.descriptions.success', { courseName })
        : t('enroll_course_modal.descriptions.success_no_name')
    }
    if (variant === 'already-member') {
      return t('enroll_course_modal.descriptions.already_member')
    }
    return t('enroll_course_modal.descriptions.no_payment')
  })()

  const handleGoToCourse = () => {
    modal.hide()
    if (courseUrl) {
      history.push(courseUrl)
    }
  }

  const handleLeave = async () => {
    try {
      await API.request()
        .endpoint(Endpoints.geograffee)
        .url('/api/LMS/RemoveMemberFromExternalCourse')
        .body({ teamId })
        .post()
        .send()
    } catch (err) {
      console.error('[EnrollCourseModal] leave course error', err)
    }
    modal.hide()
  }

  const showGoToCourse = variant !== 'no-payment'
  const showLeave = variant !== 'no-payment' && !isPaidCourse

  return (
    <Wrapper>
      <CloseWrapper>
        <IconCloseMob onClick={() => modal.hide()} />
      </CloseWrapper>

      <Title>{t(TITLE_KEYS[variant])}</Title>
      <Description>{description}</Description>

      <ButtonRow>
        <ActionButton width={220} variant={ButtonVariant.Hollow} onClick={() => modal.hide()}>
          {t('enroll_course_modal.buttons.close')}
        </ActionButton>
        {showGoToCourse && (
          <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleGoToCourse}>
            {t('enroll_course_modal.buttons.go_to_course')}
          </ActionButton>
        )}
        {showLeave && (
          <ActionButton width={220} variant={ButtonVariant.Filled} onClick={handleLeave}>
            {t('enroll_course_modal.buttons.leave_course')}
          </ActionButton>
        )}
      </ButtonRow>
    </Wrapper>
  )
}
